<div class="container-tig">
    <div class="title gyzt-title">
        <div class="t-left">
            <h4>蒙古文无衬线报体字形集</h4>
        </div>
        <div class="t-right">
            <h4>流水号：2018Z11L216016</h4>
        </div>
    </div>
    <div style=" text-align: center;
letter-spacing: 12px;">作品说明书</div>
    <br>
    <br>
    <div> 作品名称：蒙古文无衬线报体字形集</div>
    <div>作品类型：美术作品 </div>
    <br>
    <p>一、创作目的 当今是网络化时代，智能手机、平板电脑等电子产品已经成为人们生活、学习、工作不可或缺的必品。但是，现有蒙古文字体都不太适应这一“时代需求”，已成为制约蒙古文在电子产品中广泛应用的重要因素之一。</p>
    <br>
    <p>为了探索、发展和丰富蒙古文字体及其设计方法，在培养和提高蒙古文字体设计能力的同时，面向机、平板等电子产品（屏幕）的应用需求，基于“蒙古文报体”的笔画及其结构特点，借用现代拉丁文、阿拉伯文无衬线字体的笔形和笔法（特点）设计了本作品。</p>
    <br>
    <p>二、创作过程 设计之初，从丰富的传统蒙古文图书文献中寻找并学习风格特殊的字体（形），感受这些风格特殊传统蒙古文字体（形）的创作目的和呈现的效果，从中寻找创作灵感。</p>
    <br>
    <p>例如：传统蒙古文杂志《影剧》1990年3期中一幅摄影作品的说明文字的“笔形”极具冲击力（图2.1），有别于现代蒙古文字体；传统蒙古文图书《蒙古族文献优秀遗产》的标题文本的风格突出（图2.2），其中部分蒙古文“笔画”极其紧凑、识读性很强，这是我们寻求已久的特点。对此，我们基于传统蒙古文文献经典《甘珠尔》（清内府刻本，1720年，图2.3）和上世纪初的经典蒙古文字体（图2.4）进行了对比分析，总结后获得了基本设计思路和字形结构雏形。</p>
    <br>
    <div class="gyzt-img">
        <img src="./assets/images/Gyzt/gyzt-1.jpg" alt="Onon Font - 杂志《影剧》1990年3期">
        <p>图2.1：杂志《影剧》1990年3期</p>
    </div>
    <div class="gyzt-img">
        <img src="./assets/images/Gyzt/gyzt-2.jpg" alt="Onon Font - 图书《蒙古族文献优秀遗产》">
        <p>图2.2：图书《蒙古族文献优秀遗产》</p>
    </div>
    <div class="gyzt-img">
        <img src="./assets/images/Gyzt/gyzt-3.jpg" alt="Onon Font - 文献《甘珠尔》清内府刻本，1720年">
        <p>图2.3：文献《甘珠尔》清内府刻本，1720年</p>
    </div>
    <div class="gyzt-img">
        <img src="./assets/images/Gyzt/gyzt-4.jpg" alt="Onon Font - 上世纪初经典蒙古文字体">
        <p>图2.4：上世纪初经典蒙古文字体</p>
    </div>
    <p>蒙古文报体”是蒙古文现代出版中常见字体之一。蒙古文报体的风格特点突出，其笔画舒展、线条流畅、笔画结构简单且紧凑，同时其笔画结构也已非常稳定。研究发现，蒙古文报体在小字号可读性方面有“先天”优势。</p><br>
    <p>以“蒙古文报体”的笔画及其结构为基础，借鉴电子产品中应用广泛的拉丁文、阿拉伯文无衬线字体的笔形、笔法（特点），本作品用专业矢量图形设计软件完成了图（字）形集，其中包含48个独立图（字）形（请看“附件：图（字）形集”）。</p><br>
    <p>目前，本作品已涵盖传统蒙古文的基础字形。初步产品化试验（图2.5）证明，本作品已具备基于国家标准《信息技术 传统蒙古文名义字符、变形显现字符和控制字符使用规则（GB 25914-2010）》开发现代蒙古文计算机字库的初始条件。</p><br>
    <div class="gyzt-img">
        <img src="./assets/images/Gyzt/gyzt-5.jpg" alt="蒙古文无衬线报体 - 初步产品化试验">
        <p>图2.5：初步产品化试验</p>
    </div>
    <p>当然，本作品存在诸多的成熟或不满意的地方，例如：几组大曲线的半径（图2.6）、折线角度等。部分图（字）形还需要通过实际应用中进行检验和优化修订，例如：传统蒙古文辅音字母HA（阳性）词首（图2.7）笔画设计、传统蒙古文辅音字母BA和PA字形（图2.8）的对比比例等。</p><br>
    <div class="gyzt-img">
        <img src="./assets/images/Gyzt/gyzt-6.jpg" alt="蒙古文无衬线报体 - 大曲线的半径和折线角度（手稿）">
        <p>图2.6：大曲线的半径和折线角度（手稿）</p>
    </div>
    <div class="gyzt-img">
        <img src="./assets/images/Gyzt/gyzt-7.jpg" alt="蒙古文无衬线报体- 传统蒙古文辅音字母HA（阳性）词首笔画">
        <p>图2.7：传统蒙古文辅音字母HA（阳性）词首笔画</p>
    </div>
    <div class="gyzt-img">
        <img src="./assets/images/Gyzt/gyzt-8.jpg" alt="蒙古文无衬线报体 - 传统蒙古文辅音字母BA和PA字形的对比">
        <p>图2.8：传统蒙古文辅音字母BA和PA字形的对比</p>
    </div>
    <p>本作品不仅继承了蒙古文报体的笔画舒展、线条流畅、笔画结构简单且紧凑等特点，还因借鉴了拉文、阿拉伯文无衬线字体的笔形、笔法特点，从而获得了单位面积信息量大、小屏幕小字号显示清晰、适应多终端等特点，产品化试验上获得了全新的体验。</p>
    <br>
    <p>本作品的设计创作始于2017年03月，经过近一年半的努力，于2018年07月基本完成基础矢量图（字）形集的设计。</p>
    <br>
    <p>三、独创性声明 该作品由内蒙古社会科学院蒙古语信息技术研发（MIT）中心的呼斯勒独立创作完成，且不存在抄袭、复制他人作品的情形。
    </p>
    <br>
    <p>四、合作实施产品化 为了推广应用该作品（科研成果）并实现社会效益，内蒙古社会科学院（蒙古语信息技术研发中心）和内蒙古斡仑科技有限公司达成合作并成立“联合产品化工作团队”实施产品化和推广应用。
    </p>
    <br>
    <p>内蒙古社会科学院的作者及其团队负责“蒙古文无衬线报体”的进一步设计和优化工作，并协助联合产品化工作团队实施产品化，并共享蒙古文字库。</p>
    <br>
    <p>内蒙古斡仑科技有限公司负责实施“蒙古文无衬线报体”的产品化并推广应用该蒙古文字库，承担该蒙古文字库产品的维护、技术服务等些列工作。</p>
    <br>
    <br>
</div>